import { Link } from "react-router-dom";
import { categories } from "@/mocks/hotNews";

export default function Footer() {
  return (
    <footer className="mt-auto bg-primary-700 text-background-100">
      <div className="container-x py-12 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent-500 text-primary-950">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-2xl text-background-50 tracking-wide">在线吃瓜</span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/90">
              在线吃瓜是一个追踪全网热门话题与新鲜事的资讯平台。我们用实时榜单帮你快速锁定此刻大家正在关注的焦点，不错过任何一条劲爆动态，让吃瓜更有条理、也更清醒。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {[
                { icon: "ri-wechat-line", label: "微信" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-live-line", label: "直播" },
                { icon: "ri-mail-line", label: "邮件" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href="#contact"
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-50 transition-colors hover:bg-accent-500"
                >
                  <i className={s.icon}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-lg text-background-50">内容频道</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link to={`/news?category=${c.id}`} className="inline-flex items-center gap-2 text-background-200/90 hover:text-accent-300 transition-colors">
                    <i className={c.icon}></i>
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="font-heading text-lg text-background-50">站点导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                { to: "/", label: "首页" },
                { to: "/ranking", label: "实时榜单" },
                { to: "/news", label: "最新资讯" },
                { to: "/about", label: "关于我们" },
                { to: "/contact", label: "联系我们" },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-background-200/90 hover:text-accent-300 transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="font-heading text-lg text-background-50">联系方式</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-200/90">
              <li className="flex items-center gap-2"><i className="ri-mail-fill text-accent-300"></i>feedback@zgchigua.cn</li>
              <li className="flex items-center gap-2"><i className="ri-time-line text-accent-300"></i>榜单每 5 分钟更新</li>
              <li className="flex items-center gap-2"><i className="ri-chat-1-line text-accent-300"></i>工作日 9:00-21:00</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/15 pt-6 text-xs text-background-200/70 sm:flex-row">
          <p>© {new Date().getFullYear()} 在线吃瓜 · 追踪热门话题，不错过任何新鲜事。</p>
          <div className="flex items-center gap-4">
            <span>真实 · 及时 · 有温度</span>
            <span className="hidden sm:inline">zh-CN</span>
          </div>
        </div>
      </div>
    </footer>
  );
}